import { render, staticRenderFns } from "./lotteryCard_type2.vue?vue&type=template&id=7e5fb9fc&scoped=true"
import script from "./lotteryCard_type2.vue?vue&type=script&lang=js"
export * from "./lotteryCard_type2.vue?vue&type=script&lang=js"
import style0 from "./lotteryCard_type2.vue?vue&type=style&index=0&id=7e5fb9fc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e5fb9fc",
  null
  
)

export default component.exports